import { API_URL } from '../config/api';

export const fetchQuizzes = async (page = 0, size = 12) => {
    const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString()
    });
    const response = await fetch(`${API_URL}/quizes?${params}`, {
        credentials: 'include',
    });

    if (!response.ok) {
        throw new Error('Nepodařilo se načíst kvízy');
    }

    return response.json();
};

export const fetchQuiz = async (id) => {
    const response = await fetch(`${API_URL}/quizes/${id}`, {
        credentials: 'include',
    });

    if (!response.ok) {
        throw new Error('Nepodařilo se načíst kvíz');
    }

    return response.json();
};

export const updateQuiz = async (id, quizData) => {
    const response = await fetch(`${API_URL}/quizes/${id}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(quizData),
    });

    if (!response.ok) {
        throw new Error('Nepodařilo se aktualizovat kvíz');
    }

    return response.json();
};

export const createQuiz = async (quizData) => {
    const response = await fetch(`${API_URL}/quizes`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(quizData),
    });

    if (!response.ok) {
        throw new Error('Nepodařilo se vytvořit kvíz');
    }

    return response.json();
};
